import React from 'react';
import Divider from '@mui/material/Divider';
import NoteEditor from './NoteEditor';
import NotesList from './NotesList';

/**
 * EventNotesSection - Complete notes section with editor and list
 * @param {string} noteText - Current note text
 * @param {Function} onNoteTextChange - Callback when note text changes
 * @param {Function} onSave - Callback when save is clicked
 * @param {Function} onCancel - Callback when cancel is clicked
 * @param {boolean} saving - Whether note is being saved
 * @param {boolean} isEditing - Whether in edit mode
 * @param {boolean} isListening - Whether speech recognition is active
 * @param {Function} onStopListening - Callback to stop speech recognition
 * @param {Function} onFocus - Callback when text field is focused
 * @param {Function} onBlur - Callback when text field loses focus
 * @param {Array} notes - Existing notes
 * @param {number} editingNoteIndex - Index of note being edited
 * @param {Function} onEditNote - Callback when note is clicked for editing
 * @param {Function} onDeleteNote - Callback when delete is clicked
 * @param {string} borderColor - Border color for notes (optional)
 */
export default function EventNotesSection({
  noteText,
  onNoteTextChange,
  onSave,
  onCancel,
  saving,
  isEditing,
  isListening,
  onStopListening,
  onFocus,
  onBlur,
  notes,
  editingNoteIndex,
  onEditNote,
  onDeleteNote,
  borderColor
}) {
  return (
    <>
      <Divider sx={{ my: 2 }} />

      <NoteEditor
        noteText={noteText}
        onNoteTextChange={onNoteTextChange}
        onSave={onSave}
        onCancel={onCancel}
        saving={saving}
        isEditing={isEditing}
        isListening={isListening}
        onStopListening={onStopListening}
        onFocus={onFocus}
        onBlur={onBlur}
      />

      <NotesList
        notes={notes}
        editingNoteIndex={editingNoteIndex}
        onEditNote={onEditNote}
        onDeleteNote={onDeleteNote}
        saving={saving}
        borderColor={borderColor}
      />
    </>
  );
}
